import { Pipe, PipeTransform } from '@angular/core';
import { Commodity } from './../../common/_models/commodity';
import { CommodityService } from '../../common/_services';
@Pipe({
  name: 'datacommodity',
  pure: true,
  standalone: false,
})
export class DatacommodityPipe implements PipeTransform {
  private commoditySelected: Commodity = new Commodity();

  constructor(private commodityService: CommodityService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }
    this.commoditySelected = this.commodityService.getLocalCommodityById(+value);
    if (this.commoditySelected) {
      return this.commoditySelected;
    } else {
      const empty_result = {
        name: 'no Cultivation',
      };
      return empty_result;
    }
  }
}
